import { responseToPagingUi } from '@/hooks/pagingMapper';
import { useGetSellerOrders } from '@/hooks/sellerOrders/useGetSellerOrders';
import { sellerOrderResponseToSellerOrderItem } from '@/hooks/sellerOrders/useGetSellerOrders/mapper';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useImmer } from 'use-immer';
import {
  initialState,
  SellerOrderItemUi,
  SellerOrdersUi,
} from './SellerOrdersUi';

export function useSellerOrdersViewController() {
  const [uiState, setUiState] = useImmer<SellerOrdersUi>(initialState);

  const [currentPage, setCurrentPage] = useState(1);
  const { data, isLoading } = useGetSellerOrders(currentPage);

  const navigate = useNavigate();

  useEffect(() => {
    setUiState((draft) => {
      draft.isLoading = isLoading;
      if (draft.isLoading) {
        draft.paging = undefined;
        draft.items = [];
      }
    });
  }, [isLoading]);

  const onOrderClicked = (item: SellerOrderItemUi) => {
    navigate(`/seller/orders/${item.orderDetailId}`);
  };

  useEffect(() => {
    if (!data) return;
    setUiState((prev) => {
      prev.paging = responseToPagingUi(data);
      prev.items = data.data?.map(sellerOrderResponseToSellerOrderItem) ?? [];
    });
  }, [data]);

  const onPageRequested = (page: number) => setCurrentPage(page);

  return {
    uiState,
    actions: {
      onPageRequested,
      onOrderClicked,
    },
  };
}
